import config from 'rlink-debug-utils/config';
const MAX_JSON_STRING = 1024 * 1;
export default function jsonify (obj) {
  if (config.JSONIFY_OBJECT_OUTPUT) {
    let string = JSON.stringify(obj);
    if (string && string.length > MAX_JSON_STRING) {
      string = string.slice(0, MAX_JSON_STRING) + `... <snip ${string.length - MAX_JSON_STRING} more chars>`;
    }
    return string;
  } else {
    return obj;
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-debug-utils/jsonify.js